module.exports = __webpack_public_path__ + "img/T-Tomaia180_ok.c965d105.png";